import MainBlockLayout from '../../components/MainBlockLayout';
import { Button, Image, Row } from 'react-bootstrap';
import { t } from 'i18next';
import ukrainian from '../../images/ukrainian.svg';

function MainBlock() {
    const REFISTRATION_FORM_LINK = "https://app.upshot.org.uk/signup/4a120cd8/";

    return (
        <>
            <Row className="align-items-center justify-content-center" md={5} style={{ marginBottom: '25px' }}>
                <Image src={ukrainian} />
            </Row>

            <p>Шановні Батьки,</p>
            <b>Умови реєстрації дітей до Української Школи Пречистої Діви Марії при Відділі СУБ у Лондоні.</b>
            <p>За останні кілька років число учнів Української Школи Пречистої Діви Марії значно збільшилось. Факт, що Школа набрала такої популярності має надзвичайно позитивне значення для нашої громади. Проте розмір шкільного приміщення не завжди  дозволяє прийняти усіх бажаючих навчатися в Школі, в наслідок чого Дирекція Української Школи та Управа Відділу СУБ у Лондоні розробили власні критерії вступу дітей до Школи.</p>
            <b>Критерії для вступу до Української Школи Пречистої Діви Марії при Відділі СУБ у Лондоні.</b>
            <ol>
                <li>Діти, чиї батьки активно приймають участь в житті громади або активно підтримують благочинні та волонтерські організації в Україні, а також діти членів управи СУБ, СУМ, Пласт, ОУЖ, Євромайдан Лондон.</li>
                <li>Діти, брат або сестра котрих уже навчаються у Школі.</li>
                <li>Приналежність до Українських Християнських Церков.</li>
                <li>Усі інші бажаючі, які готові приймати активну участь в житті громади.</li>
            </ol>
            <p>Наголошуємо, що остаточне рішення про прийняття кандидата затверджує Приймальна Комісія Школи після проведення співбесіди з батьками учня .</p>
            <p>Згідну Статуту Школи вступ до класу Передшкілля можливий після того, як дитині виповнилось 5 років.</p>
            <p>Відбір учнів Приймальною Комісією Школи відбувається у травні. Анкети ,подані після  1-го травня,  розглядатимуться на наступний навчальний рік . Анкети повинні обов’язково бути подані Адміністратору Школи поштою (не електронною) або під час візиту до школи.</p>

            <a href={REFISTRATION_FORM_LINK} target="_blank" rel="noreferrer">
                <Button variant="primary">{t('Registration Form')}</Button>
            </a>
        </>
    )
}

export default MainBlockLayout(MainBlock);